module.exports = __webpack_public_path__ + "static/portfolio-mas-8-5b5d495137026a03a480942b56deb909.jpg";